 var domainIP = "https://web.vimass.vn/"; 
  // var domainIP ="http://118.69.84.243:28080/"
export const apiChiTietBaiViet = domainIP+"vmbank/services/quangCaoUuDai/getDetail";
export const  apiLayChiTietDanhMuc = domainIP+"vmbank/services/categoryAdv/getDetailVer2";

export const apiThongKeVpass = "http://113.190.248.142:58080/autobank/services/vimassTool/dpTuVer2";

